<nav class="navbar">
  <div class="navbar__logo">
    <img src="assets/images/side-nav-bar/sdx__logo.svg" alt="SDEX icon" class="navbar__logo-icon" />
    <svg class="navbar__logo-wordmark hidden sm:block" viewBox="0 0 88 35" fill="none" xmlns="http://www.w3.org/2000/svg"
      aria-label="SDEX">
      <path
        d="M12.1163 27.4859V21.4656C12.1163 21.0119 12.0132 20.6978 11.8071 20.5233C11.601 20.3139 11.2404 20.2092 10.7251 20.2092H6.19109C2.13791 20.2092 0.111328 18.2548 0.111328 14.346V6.75514C0.111328 2.9161 2.27531 0.996582 6.60328 0.996582H12.8891C17.2171 0.996582 19.3811 2.9161 19.3811 6.75514V11.1002H12.0132V7.80215C12.0132 6.92964 11.5495 6.49338 10.6221 6.49338H8.8703C7.94288 6.49338 7.47917 6.92964 7.47917 7.80215V13.6654C7.47917 14.1191 7.58222 14.4507 7.78831 14.6601C7.99441 14.8346 8.35507 14.9218 8.8703 14.9218H13.3013C15.4996 14.9218 17.0797 15.4104 18.0415 16.3876C19.0032 17.3299 19.4841 18.7434 19.4841 20.628V28.4806C19.4841 32.3545 17.3201 34.2915 12.9922 34.2915H6.75785C2.39553 34.2915 0.214375 32.3545 0.214375 28.4806V24.1878H7.58222V27.4859C7.58222 28.3584 8.04593 28.7947 8.97335 28.7947H10.7251C11.6526 28.7947 12.1163 28.3584 12.1163 27.4859Z"
        fill="white" />
      <path
        d="M44.0154 13.133C44.0154 13.1117 44.0154 13.0904 44.0154 13.0718V12.9812L44.0074 12.9599C43.9621 12.2462 43.6505 11.5404 42.9474 10.8772L34.2304 2.17624C33.7457 1.71549 33.1438 1.4758 32.4487 1.40921L32.3448 1.37992H24.4428C23.3083 1.37459 22.6744 2.00046 22.5732 3.29216V4.5519L22.4507 31.8187C22.448 32.7002 23.1618 33.4193 24.0433 33.4193H32.747C44.1352 33.0491 44.0127 21.3892 44.0127 21.3892V15.0746H44.0101L44.0154 13.1357V13.133ZM31.6337 28.4523H27.8811V7.367L32.462 7.38298V10.9518C32.4993 11.8467 33.2796 12.9226 34.4329 12.9226H39.3067V20.7793C39.3067 20.7793 39.7461 28.9077 31.6311 28.455L31.6337 28.4523Z"
        fill="white" />
      <path
        d="M31.7588 1.39597C31.7588 1.39597 33.418 1.57441 33.418 3.18571C33.418 4.797 33.418 10.342 33.418 10.342C33.4553 11.2368 33.8894 11.9692 35.0453 11.9692H42.2495C42.2495 11.9692 43.9673 12.0012 44.0073 13.4207C44.0872 12.5498 43.8022 11.6843 42.95 10.88L34.233 2.17898C33.5938 1.57175 32.7522 1.34537 31.7615 1.39864L31.7588 1.39597Z"
        fill="#F47D48" />
      <path
        d="M53.1558 29.1605H63.5026V33.7467H46.9023V0.865723H63.0712V5.45191H53.1558V14.571H61.5078V19.2078H53.1558V29.1605Z"
        fill="white" />
      <path d="M75.9218 22.6781L64.981 0.636719H71.6099L75.9218 10.7679L80.1804 0.636719H87.0783L75.9218 22.6781Z"
        fill="#F47D48" />
      <path d="M87.0759 33.7441H80.1779L75.9193 23.6129L71.6074 33.7441H64.9785L75.9193 11.7026L87.0759 33.7441Z"
        fill="white" />
    </svg>
  </div>
  <div class="navbar__links">
    <a *ngFor="let link of navLinks" [routerLink]="link.routerLink" routerLinkActive="navbar__link--active fw-bold"
      class="navbar__link">
      <fa-icon [icon]="link.icon" class="navbar__link-icon"></fa-icon>
      <span class="hidden sm:inline">{{ link.label }}</span>
    </a>
  </div>
  <div class="navbar__actions">
    <div class="navbar__credits" (click)="navigateToWallet()">
      <fa-icon [icon]="faBolt" class="navbar__credits-icon"></fa-icon>
      <span class="navbar__credits-count fw-bold">{{ credits }}<span class="hidden sm:inline"> credits</span></span>
    </div>
    <button class="navbar__new-btn" (click)="navigateToNewESign()">
      <fa-icon [icon]="faPlus" class="navbar__new-btn-icon"></fa-icon>
      <span class="hidden sm:inline">New eSign</span>
    </button>
    <div class="navbar__avatar-wrapper">
      <div class="navbar__avatar" (click)="toggleDropdown()">
        <img *ngIf="profilePic" [src]="profilePic" alt="Profile" class="navbar__avatar-img" />
        <span *ngIf="!profilePic" class="navbar__avatar-initials">
          {{ userInitials }}
        </span>
      </div>
      <div class="navbar__dropdown" *ngIf="showDropdown" @fadeIn>
        <button class="navbar__dropdown-item" (click)="logout()">
          <fa-icon icon="sign-out-alt" class="navbar__dropdown-icon"></fa-icon>
          Logout
        </button>
      </div>
    </div>
  </div>
</nav>